import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import CodeInputField from '../CodeInputField';

const CodeAuth = ({
  onResend,
  onSuccess,
  additionalErrors,
  showResend = true,
  canStartCount = true,
  ...rest
}) => {
  const errors = useSelector(state => state.auth.verifyErrors);
  const phoneNumber = useSelector(state => state.auth.phoneNumber);
  const session = useSelector(state => state.auth.session);

  const [formErrors, setFormErrors] = useState(undefined);

  useEffect(() => {
    const fieldErrors = errors || additionalErrors ? {...errors, ...additionalErrors} : undefined;
    setFormErrors(fieldErrors);
  }, [errors, additionalErrors])

  const handleSuccess = (data) => {
    if (formErrors !== undefined) setFormErrors(undefined);
    onSuccess && onSuccess({
      ...data,
      phone_number: phoneNumber,
      session: session || ''
    });
  }

  return (
    <CodeInputField
      errors={formErrors}
      onResend={onResend}
      onSuccess={handleSuccess}
      showResend={showResend}
      initialSeconds={179}
      canStartCount={canStartCount}
      {...rest}
    />
  );
}

CodeAuth.propTypes = {
  onResend: PropTypes.func,
  onSuccess: PropTypes.func,
  showResend: PropTypes.bool,
  canStartCount: PropTypes.bool,
  additionalErrors: PropTypes.object
}

export default CodeAuth;
